<template>
    <div class="input-group" :style="fieldStyles(input_mask)">
      <field-icon :fieldData="fieldData"></field-icon>

      <the-mask
      :disabled="(!!showDisabled())"
      :name="fieldData.field_name + '_masked'"
      :id="fieldData.field_name + '_masked'"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      type="text"
      autocomplete="off"
      placeholder="MM/YYYY"
      v-model="fieldValue"
      :mask="input_mask"
      size="10"
      :masked="true"
      v-validate="field_rules"
      v-bind:class="{'form-control': true,
        'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </the-mask>
      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
      <input
      :disabled="(!!showDisabled())"
      v-show="false"
      :name="fieldData.field_name"
      type="text"
      class="form-control"
      :maxlength="fieldData.max_length"
      v-model="fieldData.field_value"
      v-validate="field_rules">

    </div>
</template>

<script>
// TODO: Remove eslint
/* eslint-disable */
import { mask } from 'vue-the-mask';
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  directives: { mask },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  mixins: [inputFieldMixin],
  components: { FieldIcon },
  data() {
    return {
      input_mask: '##/####',
      fieldValueMasked: null,
    };
  },
  mounted() {
    let flowType = sessionStorage.getItem('flowType');
    let autoBound = sessionStorage.getItem('autobound');
    let homeBound = sessionStorage.getItem('homebound');
    if (flowType === 'bundle') {
      if ((autoBound == 'true' && this.fieldData.field_name == 'QTE_CreditCardExpirationDate') || (homeBound == 'true' && this.fieldData.field_name == 'QTE_PRP_CreditCardExpirationDate')) {
        this.fieldValueMasked = this.fieldData.field_value;
      }
    }
  },
  computed: {
    fieldValue: {
      get() {
        return this.fieldValueMasked;
      },
      set(newValue) {
        this.fieldValueMasked = newValue;
        this.fieldData.field_value = this.fieldValueMasked;
      },
    },
  },
  updated() {
    this.fieldValue = this.fieldValue; // TODO: Remove this hack to force computed value to fetch its MM/YYYY value.
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputDatemmyyyy.vue?03461266